import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseStorageDetailService {

  constructor(private http: HttpClient) {
  }

  getAllBy(url): Observable<any> {
    return this.http.get(url, Headers.contentType);
  }

  getReportOf(url): Observable<any> {
    return this.http.get(url, {responseType: 'blob'});
  }
}
